// extracted by mini-css-extract-plugin
export default {"container":"rowmosaic_container__qiM2B","mosaic":"rowmosaic_mosaic__b-0Zq"};